import { Directive } from "@angular/core";

import { TemplateMarkerDirective } from "directives/template-marker.directive";

/**
 * Marks the template to be projected as the dropdown's menu content.
 * `app-dropdown` stamps this template only while open, so the menu content
 * is created and destroyed alongside the menu rather than merely hidden.
 */
@Directive({
  selector: "[appDropdownContent]",
})
export class DropdownContentDirective extends TemplateMarkerDirective {}
